import { TCustomFilterSchemaPayload } from 'modules/_common/models';
import { TFormikInitialValues } from 'modules/accommodations/features/rentals/RentalsList/models/IProperty';
import API from 'services/api';

export const insertCustomFilter = ({
  payload,
  filterId,
}: {
  payload: TCustomFilterSchemaPayload | TFormikInitialValues;
  filterId?: string | null;
}) =>
  !filterId
    ? API.post('/api/users/filters', payload)?.then(response => response?.data)
    : API.put(`/api/users/filters/${filterId}`, payload)?.then(response => response?.data);
